import * as actions from '../actionTypes'
const initialState = [];

const attendancesReducer = (state = initialState, action) => {
    switch (action.type) {
        case actions.DELETE_ATTENDANCE:
            return state.filter((attendance) => attendance._id !== action.payload);
        case actions.SET_ATTENDANCES:
            return action.payload;

        case actions.ADD_ATTENDANCE:
            return [...state, action.payload];
        case actions.MARK_ATTENDANCE:
            return [...state, action.payload];

        case actions.UPDATE_ATTENDANCE: {
            return state.map((attendance) => attendance._id === action.payload._id ? action.payload : attendance);
        }
        default:
            return state;
    }
};

export default attendancesReducer;

